import globalStyles from "../../../assets/styles/base/globalPage.module.scss";
import primaryComponents from "../../primaryComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import secondaryComponents from "..";
import {
  DocumentationIcon,
  LogoutIcon,
  SettingIcon,
  SupportIcon,
} from "../../../assets/svgIcons";
import { getPlatform, logoutHandler } from "../../../helpers";
import styles from "./MoreModal.module.scss";
import { useContext, useState } from "react";
import { pathConstants } from "../../../routes/pathContants";
import { matchPath, useNavigate, useLocation } from "react-router-dom";
import { platformHandler } from "../../../hooks/context";
import SupportOption from "../SupportModal";
import { RoutedModal } from "../../common";
import { BsChat } from "react-icons/bs";
import { useSelector } from "react-redux";

const MoreOption = ({ closeModal }) => {
  const [isSetting, setIsSetting] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { platform } = useContext(platformHandler);
  const toggleSettingDropdown = () => {
    setIsSetting((prev) => !prev);
  };
  const [isSupportModalOpen, setIsSupportModalOpen] = useState(false);
  const {
    businessDetails: { enable_figure_flow },
  } = useSelector((state) => state.profileDetailsReducer);

  const handleMenuClick = (path) => {
    navigate(path);
    closeModal();
  };

  return (
    <>
      <div>
        <h5 className="p-2">More</h5>
        <hr />
        <div className={`${globalStyles.pageColumnGaps} p-2`}>
          {enable_figure_flow ? (
            <div
              className={`${styles.hoverEffect}`}
              onClick={() => {
                handleMenuClick(pathConstants.AI_ASSISTANCE);
              }}
              style={{ cursor: "pointer" }}
            >
              <BsChat fontSize={"22px"} />
              <span className="small-text-size m-1">AI Assistance</span>
            </div>
          ) : null}

          <div
            className={`${styles.hoverEffect}`}
            onClick={(e) => {
              e.stopPropagation();
              window.open(
                "https://enlumidatainc.zohodesk.com/portal/en/kb/enlumi-data-inc",
              );
            }}
            style={{ cursor: "pointer" }}
          >
            <DocumentationIcon />
            <span className="small-text-size m-1">Documentation</span>
          </div>
          <div className={"d-flex justify-content-between"}>
            <div
              className={`${styles.hoverEffect}`}
              onClick={toggleSettingDropdown}
            >
              <SettingIcon
                strokeColor={
                  matchPath(getPlatform(platform) + "/settings/*", pathname)
                    ? "#7647ee"
                    : undefined
                }
              />
              <span
                className={`${
                  matchPath(getPlatform(platform) + "/settings/*", pathname)
                    ? "purple--text"
                    : "dark--text"
                } small-text-size m-1`}
              >
                Settings
              </span>
            </div>

            <primaryComponents.Button
              classNames={`btn btn--outline ${styles.icon}`}
              onClick={toggleSettingDropdown}
            >
              <FontAwesomeIcon
                className={`${isSetting ? "purple--text" : "dark--text"}`}
                icon={`${isSetting ? "angle-up" : "angle-down"}`}
                fontSize={"12px"}
              />
            </primaryComponents.Button>
          </div>
          {isSetting && (
            <div className={`${globalStyles.pageColumnGaps} ml-5`}>
              <span
                className={`${styles.hoverEffect} small-text-size`}
                onClick={() => handleMenuClick(pathConstants.SETTINGS_PROFILE)}
              >
                Profiles
              </span>
              <secondaryComponents.NavigateWithPermission
                permissionParentKey={"Settings"}
                permissionChildKey={"can_create_update_and_invite_users"}
              >
                <span
                  className={`${styles.hoverEffect} small-text-size`}
                  onClick={() => handleMenuClick(pathConstants.SETTINGS_USERS)}
                >
                  Users
                </span>
              </secondaryComponents.NavigateWithPermission>
              <secondaryComponents.NavigateWithPermission
                permissionParentKey={"Settings"}
                // permissionChildKey={"can_create_update_and_invite_users"}
              >
                <span
                  className={`${styles.hoverEffect} small-text-size`}
                  onClick={() =>
                    handleMenuClick(pathConstants.SETTINGS_PLATFORM_CREDIT)
                  }
                >
                  Platform Credit
                </span>
              </secondaryComponents.NavigateWithPermission>

              <secondaryComponents.NavigateWithPermission
                permissionParentKey={"Settings"}
                permissionChildKey={"can_create_update_and_invite_users"}
              >
                <span
                  className={`${styles.hoverEffect} small-text-size`}
                  onClick={() =>
                    handleMenuClick(
                      pathConstants.SETTINGS_SECURITY_PIN_QUESTION,
                    )
                  }
                >
                  Security
                </span>
              </secondaryComponents.NavigateWithPermission>
              <secondaryComponents.NavigateWithPermission
                permissionParentKey={"Settings"}
                permissionChildKey={"can_edit_and_update_settlement_accounts"}
              >
                <span
                  className={`${styles.hoverEffect} small-text-size`}
                  onClick={() =>
                    handleMenuClick(pathConstants.SETTINGS_SETTLEMENTS)
                  }
                >
                  Settlements
                </span>
              </secondaryComponents.NavigateWithPermission>
              <secondaryComponents.NavigateWithPermission
                permissionParentKey={"Settings"}
                permissionChildKey={"can_view_update_api_key"}
              >
                <span
                  className={`${styles.hoverEffect} small-text-size`}
                  onClick={() =>
                    handleMenuClick(pathConstants.SETTINGS_APIKEYS)
                  }
                >
                  API
                </span>
              </secondaryComponents.NavigateWithPermission>
              <secondaryComponents.NavigateWithPermission
                permissionParentKey={"Settings"}
                permissionChildKey={"can_update_subscriptions"}
              >
                <span
                  className={`${styles.hoverEffect} small-text-size`}
                  onClick={() =>
                    handleMenuClick(pathConstants.SETTINGS_SUBSCRIPTIONS)
                  }
                >
                  Subscriptions
                </span>
              </secondaryComponents.NavigateWithPermission>
              <span
                className={`${styles.hoverEffect} small-text-size`}
                onClick={() =>
                  handleMenuClick(pathConstants.INVENTORY_PRINTER_CONFIGURATION)
                }
              >
                Print
              </span>
            </div>
          )}

          <div
            className={`${styles.hoverEffect} align-items-center`}
            onClick={() => setIsSupportModalOpen(true)}
          >
            <SupportIcon />
            <span className="small-text-size mt-0 ml-1">Support</span>
          </div>

          <div className={`${styles.hoverEffect}`} onClick={logoutHandler}>
            <LogoutIcon />
            <span className="small-text-size mt-0 ml-1">Log out</span>
          </div>
        </div>
      </div>

      <RoutedModal
        isActive={isSupportModalOpen}
        closeModal={() => setIsSupportModalOpen(false)}
        style={{ height: "auto" }}
        width="400px"
        headerTitle="Support"
      >
        <SupportOption />
      </RoutedModal>
    </>
  );
};

export default MoreOption;
